const Index = () => import('views/vod/Index')
const UserHome = () => import('views/user/UserHome')
const UserVideo = () => import('views/user/UserHome')
const UserImage = () => import('views/user/UserHome')
const UserAlbum = () => import('views/user/UserHome')
const UserRelation = () => import('views/user/UserRelation')

export default {
  path: '/vod/user',
  name: 'Index',
  component: Index,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'User',
      component: () => import('@/views/404.vue'),
      meta: { needAuth: false }
    },
    {
      path: '/vod/user/:id',
      name: 'UserHome',
      component: UserHome,
      meta: { needAuth: false }
    },
    {
      path: '/vod/user/:id/video',
      name: 'UserVideo',
      component: UserVideo,
      meta: { needAuth: false }
    },
    {
      path: '/vod/user/:id/image',
      name: 'UserImage',
      component: UserImage,
      meta: { needAuth: false }
    },
    {
      path: '/vod/user/:id/album',
      name: 'UserAlbum',
      component: UserAlbum,
      meta: { needAuth: false }
    },
    {
      path: '/vod/user/:id/following',
      name: 'UserFollowing',
      component: UserRelation,
      meta: { needAuth: false }
    },
    {
      path: '/vod/user/:id/follower',
      name: 'UserFollower',
      component: UserRelation,
      meta: { needAuth: false }
    }
  ]
}
